import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { KeysTabsAnalysis } from "@app/types/samples.types";
import {
  useEquipment,
  useReagents,
  useTypesUnits,
  useUser,
} from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const PreparationCommon = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { reagentsList } = useReagents();
  const { typesUnitsis } = useTypesUnits();
  const filteredProcedures = useFilteredProcedures("PRE");
  const { currentPreparation } = useAnalysis();
  const typeAnalysis = form.getValues("typeAnalysis");

  return (
    <ResponsiveFormContainer columns={5}>
      <MAutocomplete
        key={JSON.stringify(form.getValues("analysis_analyst"))}
        name="analysis_analyst"
        options={userList}
        label="Seleccione un analista"
        getOptionLabel={(option) => option.username || ""}
        validation={{ required: "El analista es requerido" }}
        disabled={!currentPreparation.canEdit}
      />

      <MAutocomplete
        key={JSON.stringify(form.getValues("preparation_procedure"))}
        name="preparation_procedure"
        options={filteredProcedures}
        label="Procedimiento MLPMA"
        getOptionLabel={(option) => `${option.numop}` || ""}
        validation={{
          required:
            filteredProcedures?.length > 0
              ? "El procedimiento es requerido"
              : false,
        }}
        disabled={!currentPreparation.canEdit}
      />
      <MDatePicker
        name="start_date"
        pickerType="date"
        label="Fecha de inicio"
        validation={{
          required: "La fecha es requerida",
        }}
        disabled={!currentPreparation.canEdit}
      />
      {typeAnalysis?.codigo !== KeysTabsAnalysis.H3_V && (
        <MTextField
          key={JSON.stringify(form.getValues("analysis_amount_sample"))}
          name="analysis_amount_sample"
          placeholder="Cantidad de muestra"
          label="Cantidad de muestra"
          type="number"
          validation={{ required: "La cantidad de muestra es requerida" }}
          fullWidth
          disabled={!currentPreparation.canEdit}
        />
      )}
      <MAutocomplete
        key={JSON.stringify(form.getValues("analysis_equipment"))}
        name="analysis_equipment"
        options={equipmentList}
        label="Seleccione un Equipo"
        getOptionLabel={(option) =>
          `${option.codigo} - ${option.descripcion}` || ""
        }
        validation={{ required: "El equipo es requerido" }}
        multiple={true}
        disabled={!currentPreparation.canEdit}
      />
      <MAutocomplete
        key={JSON.stringify(form.getValues("scintillator_lot_number"))}
        name="scintillator_lot_number"
        options={reagentsList.filter(
          (reagent) =>
            reagent.end_date_use === null && reagent.start_date_use != null
        )}
        label="Seleccione Centelleador Nº de lote"
        getOptionLabel={(option) =>
          `${option.name}${
            option.number_lot ? ` - ${option.number_lot}` : ""
          } ${option.reactive_number ? ` - ${option.reactive_number}` : ""}
          ${!option.number_lot && !option.reactive_number ? ` - Sin lote` : ""}`
        }
        validation={{ required: "El reactivo es requerido" }}
        disabled={!currentPreparation.canEdit}
      />

      <MAutocomplete
        key={JSON.stringify(form.getValues("analysis_unit_types"))}
        name="analysis_unit_types"
        options={typesUnitsis}
        label="Seleccione un tipo de unidad"
        getOptionLabel={(option) => `${option.codigo} | ${option.descripcion}`}
        validation={{ required: "El tipo de unidad es requerido" }}
        disabled={!currentPreparation.canEdit}
      />

      <MTextField
        key={JSON.stringify(form.getValues("valid_preparation"))}
        name="valid_preparation"
        placeholder="Preparación Válida"
        label="Preparación Válida"
        type="text"
        validation={{ required: "La preparación válida es requerida" }}
        fullWidth
        disabled
      />
    </ResponsiveFormContainer>
  );
};

export default PreparationCommon;
